export const certsData = [

  {
    id: 1,
    name: "Full-Stack Web Development Bootcamp",
    type: "Certificate of Completion",
    issue: "December 9th, 2022",
    issuer: "University of Texas at Dallas",
    detail: "Powered by Fullstack Academy"
  },

  {
    id: 2,
    name: "Advanced CSS & SASS",
    type: "Certificate of Completion",
    issue: "March 5th, 2023",
    issuer: "Udemy"
  },

  {
    id: 3,
    name: "The Git & GitHub Bootcamp",
    type: "Certificate of Completion",
    issue: "Feburary 14th, 2023",
    issuer: "Udemy"
  },

  {
    id: 4,
    name: "Full-Stack Software Engineer Career Path",
    type: "Certificate of Completion",
    issue: "November 15th, 2022",
    issuer: "Codecademy"
  },

  {
    id: 5,
    name: "Responsive Web Design",
    type: "Certificate of Completion",
    issue: "November 22nd, 2022",
    issuer: "freeCodeCamp"
  }

]